import React, { useEffect } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import PdfPrinter from "pdfmake";
import { useOrganization } from "../../configurations/OrganizationContext";
import {
ORG_CODES
} from "../../shared/constants";


pdfMake.vfs = pdfFonts.pdfMake.vfs;
export const DISCHARGE = "Discharge Summary";

const qz = require("qz-tray");
const printerName = process.env.REACT_APP_PRINTER_NAME;
const EMERGENCY_CONTACT_NO = process.env.REACT_APP_EMERGENCY_NUNBER;

function NotesPrint(props) {
  const org = useOrganization(); 

  const file_number = props.patientdetails.fileNo || "";
  const name =
    props.patientdetails.fname ||
    props.patientdetails.mname ||
    props.patientdetails.lname
      ? props.patientdetails.fname +
        " " +
        props.patientdetails.mname +
        " " +
        props.patientdetails.lname
      : "";
  const age =
    props.patientdetails.age || props.patientdetails.gender
      ? props.patientdetails.age + "/" + props.patientdetails.gender
      : "";
  const contact_number = props.patientdetails.phno || "";
  const city = props.patientdetails.city;
  const state = props.patientdetails.state;
  const pincode = props.patientdetails.pincode;
  const address =
    (props.patientdetails.address ? props.patientdetails.address + ", " : "") +
    (city ? city : "Arkula") +
    (state ? ", " + state : ", Karnataka") +
    (pincode ? " " + pincode : "");
  const referral = props.patientdetails.srcref || "";
  const language = props.patientdetails.language || "";
  const marital_status = props.patientdetails.sociostatus || "";
  const education = props.patientdetails.education || "";
  const occupation = props.patientdetails.occupation || "";
  const case_worked_up_by = "";
  const psychiatrist = props.patientdetails.doctor || "";
  const social_worker = "";

  const chief_complaints = props.notes["Chief Complaints"];
  const onset = props.notes.Onset;
  const duration = props.notes.duration;
  const progression = props.notes.progression;
  const precipitating_factor = props.notes["Precipitating factor"];
  const clinical_summary = props.notes["Clinical Summary"];
  const treatment_history = props.notes["Past and Treatment History"];
  const medical_history = props.notes["Relevant Medical History"];
  const family_history = props.notes["Relevant Family History"];
  const personal_history = props.notes["Personal History"];
  const premorbid_personality = props.notes["Premorbid Personality"];
  const psycho_social_factor = props.notes["Psycho-social Factors"];
  const pulse = props.notes.pulse;
  const bp = props.notes.bp;
  const weight = props.notes.weight;
  const bmi = props.notes.bmi;
  const mental_state = props.notes["Mental State Examination"];
  const provisional_diagnosis = props.notes["Provisional Diagnosis"];
  const final_diagnosis = props.notes["Final Diagnosis"];
  const consultant_notes = props.notes["Consultant Notes and Management Plan"];

  const val = new Date();

  const formattedDate = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  }).format(val);
  const date = formattedDate ? formattedDate : "";

  // const date = formattedDate ? formattedDate : "";
  useEffect(() => {
    props.parentCallBack();
    dischargeSummaryPrint();
  }, []);
  dischargeSummaryPrint();

  async function dischargeSummaryPrint() {
    let getDocDefinition;

    if (org?.orgCode === ORG_CODES.MANASWINI) {
      // Manaswini
      getDocDefinition = (await import("../../manaswini/docdefnotesprint")).getDocDefinition;
      console.log("manaswini");
      
    } else  {
      // MNH
      console.error("Invalid organization. Cannot load discharge PDF layout.");
      return;

    } 

    const docDefinition = getDocDefinition({
      name,
      file_number,
      date,
      age,
      contact_number,
      address,
      referral,
      language,
      marital_status,
      education,
      occupation,
      psychiatrist,
      social_worker,
      case_worked_up_by,
      chief_complaints,
      onset,
      duration,
      progression,
      precipitating_factor,
      clinical_summary,
      treatment_history,
      medical_history,
      family_history,
      personal_history,
      premorbid_personality,
      psycho_social_factor,
      pulse,
      bp,
      weight,
      bmi,
      mental_state,
      provisional_diagnosis,
      final_diagnosis,
      consultant_notes,
    });

    printPrescription(docDefinition);
  }

  function printPrescription(docDefinition) {
    PdfPrinter.createPdf(docDefinition).open();
    let pdf;
    const pdfDocGenerator = PdfPrinter.createPdf(docDefinition);
    pdfDocGenerator.getBase64((data) => {
      pdf = data;
    });

    qz.websocket
      .connect()
      .then(() => qz.printers.find())
      .then((printers) => {
        printers.forEach((printer) => {
          if (printer.includes(printerName)) {
            let config = qz.configs.create(printer, {
              size: { width: 148, height: 210 },
              units: "mm",
              scaleContent: false,
            });
            console.log("config is", config);
            return qz
              .print(config, [
                {
                  type: "pixel",
                  format: "pdf",
                  flavor: "base64",
                  data: pdf,
                },
              ])
              .then(() => qz.websocket.disconnect());
          }
        });
      })
      .catch((err) => console.error("Print error:", err));
  }

  return <></>;
}

export default NotesPrint;
